import { InjectionToken, ElementRef } from '@angular/core';

export interface TooltipOptions {
    placement: string;
    popupClass: string;
    animation: boolean;
    content: string;
    htmlContent: any;
    context: any;
    isOpen?: boolean;
    hostEl?: ElementRef;
}

export const TOOLTIP_OPTIONS = new InjectionToken<TooltipOptions>(
    'tooltipOptions'
);
